export default __webpack_public_path__ + "static/media/km.7600aeea.svg";